import Vue from 'vue'
// import _ from 'lodash/lodash';
import axios from '@/wrappers/axios.js'
import { getInstance } from "@/plugins/auth.js";
import JsonDenormalizer from '@/helpers/JsonDenormalizer.js';

// import store from '../../store';

const AuthService = {

    getCurrent(params) {
        params = typeof params !== 'undefined'
            ? params
            : {};
        return axios.get('/profile', { params })
            .then(response => {
                const user = JsonDenormalizer.denormalize(response.data);
                return Promise.resolve(user);
            });
    },

    teleportUser(id) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/users/${id}/teleport`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    async getAccessToken() {
        const Auth0Plugin = getInstance();
        return await Auth0Plugin.auth0Client.getTokenSilently();
    },

    getUserInfo() {
        return new Promise((resolve, reject) => {
            this.getAccessToken()
            .then(token => {
                const endpoint = `https://${process.env.VUE_APP_AUTH0_DOMAIN}/userinfo`;
                return axios.get(endpoint, {
                    headers: {
                        'Authorization': `Bearer: ${token}`,
                    }
                });
            })
            .then(response => {
                const info = response.data;
                return resolve(info);
            })
            .catch(err => {
                console.log(err);
                return reject(err);
            });
        });
    },

    getAppList() {
        return this.getUserInfo()
            .then(info => {
                const ns = process.env.VUE_APP_AUTH0_AUDIENCE;
                const clientList = info[ns + 'clients'] || [];
                return clientList;
            });
    },
    
    async getNotifications(params = null) {
        return await axios.get(`/notifications?${params ? params : ''}`).then(response=>{
            return response.data
        })
    }
}

Vue.$authService = AuthService

export default AuthService